import { ThemeProvider } from '@material-ui/styles';
/**
 * @ignore - internal component.
 * @deprecated
 */

export default ThemeProvider;